var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CustomElement from '@byted/light-render/lib/shapes/CustomElement';
import { _createSymbol as createSymbol } from '../symbol/index';
var SymbolShape = /** @class */ (function (_super) {
    __extends(SymbolShape, _super);
    function SymbolShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SymbolShape.prototype.getObservedAttr = function () {
        return ['symbol', 'x', 'y', 'width', 'height'];
    };
    SymbolShape.prototype.getDefaultAttr = function () {
        return {
            symbol: 'none',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
        };
    };
    SymbolShape.prototype.render = function () {
        var _a = this.attr, symbol = _a.symbol, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return createSymbol(symbol, x, y, width, height, {});
    };
    return SymbolShape;
}(CustomElement));
export default SymbolShape;
